export default {"src":"/_next/static/media/credit-card.d68ffe8f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};